module.exports = __webpack_public_path__ + "media/images/procne_logo_sq-b9d080f253d070437eff2d2a8e864c0e.png";